<template>

    <div class="container small">
        <div class="container loginFormWrapper" >
            <RegisterForm :nonce="registerNonce" :siteKey="siteKey" />
        </div>  
    </div>

</template>

<script>
import { mapState } from 'pinia';
import { globalStore } from "../stores/global.js";
import { registerStore }  from "../stores/register.js";

import RegisterForm from "../forms/RegisterForm.vue";

export default {
    name: "RegisterApp",
    components: {
        RegisterForm,
    },
    computed: {
        ...mapState(registerStore, {
            registerNonce: store => store.nonces.register,
        }),
        ...mapState(globalStore, {
            isUserAuthenticated: store => store.isUserAuthenticated,
            siteKey: store => store.siteKey
        })
    },
};
</script>

<style>
</style>
